import { baseTheme } from '@streamlain/theme';
import {
  css,
  html,
  LitElement,
  nothing,
  type TemplateResult,
  unsafeCSS,
} from 'lit';
import { property } from 'lit/decorators.js';

import { toolbarOverflowRowStyles } from './styles.js';

export const TOOLBAR_DOCK_ENTRY = 'toolbar-dock-entry';

/**
 * Hosts one existing toolbar template (a tool, an element option, a "More" menu) wherever an app's
 * dock puts it, as app chrome: a frame colour island, so it keeps the app's colours in any editor theme. The template stays Lit; the dock around
 * it does not need to be.
 */
export class ToolbarDockEntry extends LitElement {
  static override styles = css`
    :host {
      display: flex;
      height: 100%;
      flex-shrink: 0;
      font-family: ${unsafeCSS(baseTheme.fontSansFamily)};
      -webkit-user-select: none;
      user-select: none;
    }
    .entry {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      width: 100%;
      height: 100%;
      color: var(--streamlain-v2-text-primary);
      fill: currentColor;
    }
    ${unsafeCSS(toolbarOverflowRowStyles('.overflow-row'))}
  `;

  @property({ attribute: false })
  accessor content: TemplateResult | null = null;

  override connectedCallback() {
    super.connectedCallback();
    this.dataset.colourIsland = 'frame';
  }

  override render() {
    if (!this.content) return nothing;
    return html`<div class="entry">${this.content}</div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [TOOLBAR_DOCK_ENTRY]: ToolbarDockEntry;
  }
}
